// Generated with util/create-component.js
import Icon from './Icon';

export default Icon;
